import React, { useContext, useEffect, useState } from "react";
import styled from 'styled-components';
import ChatGlobalContext from "../context/ChatGlobalContext";

const TypingIndicator = ({sc}) => {
  const gContext: any = useContext(ChatGlobalContext);
  const [typingAgent, setTypingAgent] = useState(false);

  useEffect(() =>{
    if(sc.current && gContext?.goGetTwilioChat()?.chatCaseId){
      sc.current.emit("joinRoom", gContext?.goGetTwilioChat()?.chatCaseId);  
      !sc.current.listeners(`web-chat-input-${gContext?.goGetTwilioChat()?.chatCaseId}`).length && sc.current?.on(`web-chat-input-${gContext?.goGetTwilioChat()?.chatCaseId}`, (data) => {
        if(data.sender === "AGENT"){
          setTypingAgent(true);
        }
      });
    }
  }, [sc, gContext?.goGetTwilioChat()?.chatCaseId]);
  
  let typingTimeout:any;
  
  useEffect(() => {
    if(typingAgent){
      setTypingAgent(true);
      typingTimeout = setTimeout(() => {
        setTypingAgent(false);
        clearTimeout(typingTimeout);
      }, 3000);   
    }
  }, [typingAgent]);

  return ( typingAgent ? <Agent><small>Agent is typing...</small></Agent> : null );
};

export default TypingIndicator;

const Agent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  small {
    position: absolute;
    margin: 0px 3px 0px 0px;
    font-size: 11px !important;
    font-weight: 100;
    line-height: 13px;
    color: #015e9c;
    background-color: #ddf0fc;
    border: 1px solid #ffffff;
    border-radius: 100px;
    padding: 5px 15px;
    z-index: 50;
  }
`;